import Head from "next/head";
import Layout from "../../components/layout";
import { useUser } from "../../lib/hooks";

import Link from "next/link";
import { useRouter } from "next/router";

import Banner from "../../components/Banner";
import { Spacer, Text, Button } from "@nextui-org/react";

export const getServerSideProps = async (context) => {
  const res = await fetch(
    `${process.env.ROOT_URL}/api/journal/${context.params.id}`
  );
  if (res.status === 404) {
    // TODO add this more places
    return { props: { empty: true } };
  }
  const data = await res.json();
  return { props: { ...data } };
};

const Journal = (props) => {
  if (props.empty || !props.title) {
    return (
      <Layout>
        <div>There's nothing here.</div>
      </Layout>
    );
  }

  const router = useRouter();
  const { success, updated } = router.query;
  const user = useUser();

  return (
    <Layout>
      <Head>
        <title>{props.title} | Editorland</title>
      </Head>
      {success !== undefined && (
        <Banner type={"success"}>Your journal has been created.</Banner>
      )}
      {updated !== undefined && (
        <Banner type={"success"}>Your journal has been updated.</Banner>
      )}
      <Text h1 i>
        {props.title}
      </Text>
      <Text style={{ whiteSpace: "pre-line" }}>{props.description}</Text>
      <Spacer y={0.5} />
      <hr />
      <Spacer y={0.5} />
      <Text h2>Submission instructions</Text>
      <Text style={{ whiteSpace: "pre-line" }}>
        {props.submissionInstructions}
      </Text>
      <Spacer y={0.5} />
      <hr />
      <Spacer y={1} />
      {user ? (
        props.openForSubmissions ? (
          <Link href={props.urlName + "/submit"}>
            <Button>Submit</Button>
          </Link>
        ) : (
          <Text>This journal is currently closed to submissions.</Text>
        )
      ) : (
        <Text>
          <Link href="/login">Sign in</Link> or{" "}
          <Link href="/signup">sign up</Link> to submit to this journal.
        </Text>
      )}
      <Spacer y={0.5} />
      {user && user.id === props.creatorId && (
        <Text>
          <Link href={props.urlName + "/edit"}>
            <Button>Edit</Button>
          </Link>
          <Spacer y={0.5} />
        </Text>
      )}
      {user &&
        (user.id === props.creatorId || props.editors.includes(user.id)) && (
          <Text>
            <Link href={props.urlName + "/works/page/1"}>
              <Button>Evaluate submissions</Button>
            </Link>
            <Spacer y={0.5} />
          </Text>
        )}
      {user && user.id === props.creatorId && (
        <Text>
          <Link href={props.urlName + "/editors"}>Update journal editors</Link>
          <Spacer y={0.5} />
        </Text>
      )}
    </Layout>
  );
};

export default Journal;
